export function Button({ children, variant = "default", disabled, ...props }) {
  const base = "py-2 px-4 font-medium inline-flex items-center justify-center";

  const variants = {
    default: disabled
      ? "bg-lightgray text-white w-40"
      : "bg-customBlue text-white w-40",
    outline: disabled
      ? "bg-gray-100 text-customBlue font-semibold w-40"
      : "text-customBlue hover:bg-gray-100 font-semibold w-40",
    wide: disabled
      ? "bg-lightgray text-white whitespace-nowrap px-6"
      : "bg-customBlue text-white whitespace-nowrap px-6",
  };

  return (
    <button
      className={`${base} ${variants[variant]}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
